<img
  [style.display]="loading || inErrorState() ? 'none' : 'block'"
  [class.with-border-and-shadow]="withBorderAndShadow"
  [src]="currentUrl"
  [style.max-width]="maxWidth"
  [style.max-height]="maxHeight"
  (load)="onLoaded()"
  (error)="onError()"
/>
@if (loading) {
<mat-progress-spinner
  class="progress-spinner"
  mode="indeterminate"
  color="primary"
  value="10"
  strokeWidth="3"
>
</mat-progress-spinner>
} @if (inErrorState()) {
<div class="error">
  <mat-icon svgIcon="alert-sm"></mat-icon>
  @if(withErrorText()) {
  <p i18n="@@loadingImageErrorText">Image couldn't load</p>
  }
</div>
}
